import $ from 'jquery';
import offcanvas from './lsag.offcanvas';

const search = {
    bindEvents() {
        $('#js-sticky-search').on('click', function () {
            $('html, body').animate({ scrollTop: 0 }, "slow");
            // focus input field
            $('.c-main-search.desktop .c-main-search__input').focus();
            setTimeout(function() {
                $('.c-main-search.desktop .c-main-search__input').trigger('click');
            }, 100);
        });


    }
};

// DOM ready
$(() => {
    search.bindEvents();
});

export default search;
